import TestIds from 'util/TestIds'
import EntryFormCard from '../EntryFormCard'
import Loading from '@ui-components-3/ui/lib/components/Loading'
import EmailSchema, { EmailValues } from 'schemas/EmailSchema'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export type ForgotPasswordSceneProps = {
  email: string | null
  onBack: () => void
  onSubmit: () => void
}

const ForgotPasswordScene = (props: ForgotPasswordSceneProps) => {
  const { email, onBack, onSubmit } = props
  const { t } = useTranslation()

  const {
    formState: { isSubmitting, isSubmitted },
    handleSubmit,
  } = useForm<EmailValues>({
    defaultValues: { email: email as string },
    // TODO: Replace any typing once yup is upgraded
    resolver: yupResolver(EmailSchema as any),
  })

  return (
    <EntryFormCard
      prompt={isSubmitting ? t('login.forgotPassword.sending') : t('login.forgotPassword.title')}
      data-testid={TestIds.login.view.forgotPassword}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <p className="typography-body-l text-neutral font-medium" data-testid={TestIds.login.view.forgotPasswordPrompt}>
          {isSubmitting || isSubmitted ? t('login.forgotPassword.checkEmail') : t('login.forgotPassword.confirmPrompt')}
          <span className="text-primary">{' ' + email + ' '}</span>
          {isSubmitting || isSubmitted ? t('login.forgotPassword.followLink') : t('login.forgotPassword.questionMark')}
        </p>
        <div className="mb-2 mt-10 flex w-full items-center justify-between gap-4">
          <button
            className="btn btn-neutral-outlined w-1/2 grow"
            data-testid={TestIds.login.button.forgotPasswordCancel}
            type="button"
            onClick={onBack}
          >
            {t('common.back')}
          </button>
          {!isSubmitted ? (
            <button
              className="btn btn-primary w-1/2 grow"
              data-testid={TestIds.login.button.forgotPasswordOk}
              disabled={isSubmitting}
              type="submit"
            >
              {isSubmitting ? <Loading /> : t('login.forgotPassword.resetPassword')}
            </button>
          ) : null}
        </div>
      </form>
    </EntryFormCard>
  )
}

export default ForgotPasswordScene
